module.exports = __webpack_public_path__ + "img/Red_joker.svg.10b10b75.png";